@let sectionFormGroup = startPageSectionForm();

<aw-section testIdAffix="section-navigation" [isCollapsible]="true">
  <aw-section-header>
    <aw-section-headline>
      <div class="flex items-center">
        <div class="flex flex-col pr-2">
          @if (sectionIndex() > 0) {
            <span
              class="material-symbols-rounded cursor-pointer"
              (click)="
                moveSections.emit({
                  oldIndex: sectionIndex(),
                  newIndex: sectionIndex() - 1,
                })
              "
              >keyboard_arrow_up</span
            >
          }
          @if (sectionIndex() < lastIndex()) {
            <span
              class="material-symbols-rounded cursor-pointer"
              (click)="
                moveSections.emit({
                  oldIndex: sectionIndex(),
                  newIndex: sectionIndex() + 1,
                })
              "
              >keyboard_arrow_down</span
            >
          }
        </div>
        @if (sectionIndex() === 0) {
          {{ cmsTextProvider.shared.sectionNavigation }} ({{
            sectionFormGroup.controls.texts.value ?? [] | language
          }})
        } @else {
          {{ cmsTextProvider.shared.section }} {{ sectionIndex() }} ({{
            sectionFormGroup.controls.texts.value ?? [] | language
          }})
        }
      </div>
    </aw-section-headline>
  </aw-section-header>
  @if (isLoading()) {
    <aw-loading-animation></aw-loading-animation>
  } @else {
    <aw-translation-text-input
      [entityType]="EntityType.customTileSection"
      [formControl]="sectionFormGroup.controls.texts"
      [relationType]="TextRelationType.title"
      id="headlines"
      [label]="cmsTextProvider.shared.titleOptional" />

    <div class="-m-2 flex flex-wrap">
      @for (
        card of sectionFormGroup.controls.tiles.controls;
        track card;
        let index = $index
      ) {
        <aw-start-page-card
          class="w-1/2 p-2"
          [id]="id() + '-card-' + index"
          [sectionForm]="sectionFormGroup"
          [cardIndex]="index"
          [sectionIndex]="sectionIndex()"
          [card]="card"
          (atDelete)="deleteCard(index, sectionFormGroup.controls.tiles)">
        </aw-start-page-card>
      }
    </div>
    <aw-button
      (click)="addCard()"
      [id]="'add-card'"
      [isFullWidth]="false"
      [style]="'primary-alt'"
      [text]="cmsTextProvider.customTiles.addNewTile"
      [type]="'button'">
      <span class="material-symbols-rounded pr-2">add_2</span>
    </aw-button>

    <aw-button
      (click)="atDeleteSection.emit(sectionFormGroup.controls.id.value)"
      [id]="'delete-section'"
      [isDisabled]="sectionIndex() === 0"
      [isFullWidth]="false"
      [style]="sectionIndex() === 0 ? 'error' : 'error-alt'"
      [text]="
        sectionIndex() === 0
          ? cmsTextProvider.customTiles.cannotRemoveSection
          : cmsTextProvider.customTiles.deleteSection
      "
      [type]="'reset'">
      @if (sectionIndex() === 0) {
        <span class="material-symbols-rounded pr-2 text-black">lock</span>
      } @else {
        <span class="material-symbols-rounded pr-2">delete</span>
      }
    </aw-button>
  }
</aw-section>
